/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes              from 'prop-types';
import React                  from 'react';
import Prism                  from 'prismjs';
import styles                 from './CodeSnippet.scss';
import Icon                   from 'components/Icon/Icon.react';
import CopyToClipboard        from 'react-copy-to-clipboard';

import Tooltip                from 'rc-tooltip';

import 'prismjs/plugins/line-numbers/prism-line-numbers';
import bash from 'prismjs/components/prism-bash';
import markup from 'prismjs/components/prism-markup';
import clike from 'prismjs/components/prism-clike';
import swift from 'prismjs/components/prism-swift';
import c from 'prismjs/components/prism-c';
import objectivec from 'prismjs/components/prism-objectivec';
import java from 'prismjs/components/prism-java';
import javascript from 'prismjs/components/prism-javascript';
import csharp from 'prismjs/components/prism-csharp';

export default class CodeSnippet extends React.Component {
  constructor() {
    super();
    this.state = {
      copied: false
    };
  }

  componentDidMount() {
    this._highlight();
  }

  componentDidUpdate() {
    this._highlight();
  }

  _highlight() {
    Prism.highlightElement(this.refs.code);
  }

  handleCopy() {
    setTimeout(() => this.setState({ copied: false }), 800);

    this.setState({
      copied: true
    });
  }

  render() {
    let { fullPage = true, lineNumbers = true } = this.props;
    let classes = ['language-' + this.props.language];
    if (lineNumbers) {
      classes.push('line-numbers');
    }
    let pageStyle = fullPage ? { minHeight: '100%'} : {};

    let copyClasses = [styles.copy, this.state.copied ? styles.active : null];

    return (
      <div className={styles.CodeSnippet}>
        {this.props.copy
          ?
            <CopyToClipboard text={this.props.source}
              onCopy={this.handleCopy.bind(this)}>
              <Tooltip placement="right" overlay={'Copy to Clipboard'} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                <span className={copyClasses.join(' ')}>
                  {this.state.copied
                    ?
                      <Icon name={'icon-check'} width={16} height={16} />
                    :
                      <Icon name={'icon-copy'} width={16} height={16} />
                  }
                </span>
              </Tooltip>
            </CopyToClipboard>
          : null
        }
        <pre style={{ margin: 0, ...pageStyle}} className={classes.join(' ')}>
          <code style={pageStyle} ref='code'>{this.props.source}</code>
        </pre>
      </div>
    );
  }
}

CodeSnippet.propTypes = {
  source: PropTypes.string.isRequired,
  language: PropTypes.string,
  fullPage: PropTypes.bool,
  lineNumbers: PropTypes.bool,
};
